function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails = function SvgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M2 9.2C2 6.67976 2 5.41965 2.49047 4.45704C2.9219 3.61031 3.61031 2.9219 4.45704 2.49047C5.41965 2 6.67976 2 9.2 2H14.8C17.3202 2 18.5804 2 19.543 2.49047C20.3897 2.9219 21.0781 3.61031 21.5095 4.45704C22 5.41965 22 6.67976 22 9.2V14.8C22 17.3202 22 18.5804 21.5095 19.543C21.0781 20.3897 20.3897 21.0781 19.543 21.5095C18.5804 22 17.3202 22 14.8 22H9.2C6.67976 22 5.41965 22 4.45704 21.5095C3.61031 21.0781 2.9219 20.3897 2.49047 19.543C2 18.5804 2 17.3202 2 14.8V9.2Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.5C13.0784 8.5 13.75 7.82843 13.75 7C13.75 6.17157 13.0784 5.5 12.25 5.5C11.4216 5.5 10.75 6.17157 10.75 7C10.75 7.82843 11.4216 8.5 12.25 8.5Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.5C13.25 10.2239 13.0261 10 12.75 10H10.5C9.94772 10 9.5 10.4477 9.5 11C9.5 11.5523 9.94772 12 10.5 12H11.25V16.5H10C9.44772 16.5 9 16.9477 9 17.5C9 18.0523 9.44772 18.5 10 18.5H14C14.5523 18.5 15 18.0523 15 17.5C15 16.9477 14.5523 16.5 14 16.5H13.25V10.5Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95,
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 0.95
    }
  }));
};
export default SvgDetails;